<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<div class="p-fluid">
  <app-warehousing-page-header activeSection="refurbishment" title="Refurbishment"
    subtitle="Mark internal or outsourced refurbishment without reducing stock or billing footprint.">
    <div actions class="flex gap-2">
      <p-button label="Mark Refurbishment" icon="pi pi-plus" severity="warn" routerLink="/warehousing/refurbishment/add"></p-button>
      <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadRefurbishments()"></p-button>
    </div>
  </app-warehousing-page-header>
  <app-warehousing-search-panel title="Search Refurbishment" [resultCount]="refurbishments.length" [totalCount]="refurbishments.length" (search)="applySearch()" (clear)="clearSearch()">
    <div [formGroup]="searchForm" class="formgrid grid">
      <div class="field col-12 md:col-6">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon><p-iftaLabel><input id="refurbishmentKeyword" pInputText formControlName="keyword"><label for="refurbishmentKeyword">Keyword</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-cog"></i></p-inputGroupAddon><p-iftaLabel><p-select id="refurbishmentSource" [options]="refurbishmentSources" optionLabel="label" optionValue="value" formControlName="sourceType" [showClear]="true" styleClass="w-full"></p-select><label for="refurbishmentSource">Source</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon><p-iftaLabel><p-select id="refurbishmentStatus" [options]="refurbishmentStatusOptions" optionLabel="label" optionValue="value" formControlName="status" [showClear]="true" styleClass="w-full"></p-select><label for="refurbishmentStatus">Status</label></p-iftaLabel></p-inputGroup>
      </div>
    </div>
  </app-warehousing-search-panel>
  <section class="warehousing-table-card">
    <div class="warehousing-table-header">
      <div>
        <h2>Refurbishment Directory</h2>
        <p>Track active internal and outsourced refurbishment records.</p>
      </div>
      <span class="warehousing-result-chip">{{ refurbishments.length }} records</span>
    </div>
    <p-table [value]="refurbishments" [paginator]="true" [rows]="12" dataKey="id" styleClass="p-datatable-sm p-datatable-gridlines warehousing-data-table" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[12, 25, 50]" [tableStyle]="{ 'min-width': '56rem' }">
      <ng-template pTemplate="header"><tr><th>Refurbishment Profile</th><th>Work Scope</th><th>Cost / Status</th><th>Audit</th><th class="text-center">Actions</th></tr></ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td>
            <div class="stack-cell">
              <span class="warehousing-code-pill">Stock Unit {{ r.stockUnitId }}</span>
              <span class="cell-title">{{ itemName(r.itemId) }}</span>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <span class="cell-title">{{ r.sourceType }}</span>
              <span class="cell-meta"><i class="pi pi-building"></i> {{ supplierName(r) }}</span>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <p-tag [value]="r.status" [severity]="statusSeverity(r.status)"></p-tag>
              <div class="cell-meta vertical">
                <div class="quality-pill">Est. {{ (r.estimatedCost || 0) | number:'1.2-2' }}</div>
                <span>Actual {{ (r.actualCost || 0) | number:'1.2-2' }}</span>
              </div>
            </div>
          </td>
          <td><app-audit-directory-cell [stamp]="r"></app-audit-directory-cell></td>
          <td class="text-center"><div class="warehousing-row-actions"><p-button icon="pi pi-eye" [text]="true" [routerLink]="['/warehousing/refurbishment/view', r.id]"></p-button></div></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="5"><div class="warehousing-empty-state"><i class="pi pi-search"></i><strong>No refurbishment records found</strong><span>No matching refurbishment records.</span></div></td></tr></ng-template>
    </p-table>
  </section>
</div>
